import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// One confirm dialog for every delete / cancel / deactivate action, with an
// optional required "why" box (cancel reasons are shown to the vendor).
// onConfirm(reason) may throw an axios error; its message is shown.
export default function ConfirmAction({
  open, onOpenChange, title, description, confirmLabel = "Confirm", danger = true,
  requireReason = false, reasonPlaceholder = "Why?", onConfirm, testId = "confirm-action-dialog",
}) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setReason(""); }, [open]);

  const go = async () => {
    if (requireReason && !reason.trim()) return toast.error("Add a reason");
    setBusy(true);
    try {
      await onConfirm(reason.trim());
      onOpenChange(false);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(Array.isArray(d) ? d.map((x) => x.message || x.msg).join(" ") : d || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testId}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="space-y-3 mt-1">
          {description && <p className="text-[13px] text-slate-600">{description}</p>}
          {requireReason && (
            <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} autoFocus placeholder={reasonPlaceholder}
              data-testid={`${testId}-reason`} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-sky-400" />
          )}
          <div className="flex gap-2">
            <button onClick={() => onOpenChange(false)} disabled={busy} className="flex-1 h-10 rounded-lg border border-slate-200 text-[13px] font-semibold hover:bg-slate-50">Keep it</button>
            <button onClick={go} disabled={busy} data-testid={`${testId}-confirm`}
              className={`flex-1 h-10 rounded-lg text-white text-[13px] font-semibold disabled:opacity-60 ${danger ? "bg-red-600 hover:bg-red-700" : "bg-sky-500 hover:bg-sky-600"}`}>
              {busy ? "Working…" : confirmLabel}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
